import axios from "axios";
import { API_BASE_PATHS, API_ROUTES } from "../libs";
import { buildRequestConfig } from "./buildRequestConfig";
import { GetTemplateOrderResponse, UpdateTemplateOrderRequest } from "../libs/models/manage-template";

class TemplateService {
    async updateTemplateOrder(data: UpdateTemplateOrderRequest): Promise<GetTemplateOrderResponse> {
        const config = await buildRequestConfig();

        const response = await axios.post(
            `${process.env.REACT_APP_API_HOST}/${API_BASE_PATHS.USERS_API}/${API_ROUTES.GET_TEMPLATE_ORDER}`,
            data,
            { ...config }
        );

        return response.data;
    }

    async getTemplateOrder(): Promise<GetTemplateOrderResponse> {
        const reqConfig = await buildRequestConfig();

        const response = await axios.get(
            `${process.env.REACT_APP_API_HOST}/${API_BASE_PATHS.USERS_API}/${API_ROUTES.GET_TEMPLATE_ORDER}`,
            reqConfig
        );

        return response.data;
    }

}

export const templateService = new TemplateService();